import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import SpaCarosle from "../../Components/SpaCarosle";
import axios from "../../axios";
import Green from "../../assets/images/icons/green-leaf.png";
import { Button, Modal } from "react-bootstrap";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import "../../new-pages/hotel-services/HotelServices.scss";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { Accordion, AccordionTab } from "primereact/accordion";
import TaxInclusive from "../../Components/TaxInclusive.";
import Title from "../../new-components/title/Title";
import BannerServices from "../../new-components/banner-home/BannerServices";
import HouseImage from "../../assets/images/housekeeping.jpeg";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import Sar from "../../assets/images/icons/Sar";
import LocationVerificationModal from "../../Components/LocationVerificationModal";
import PaymentOptionList from "../../Components/PaymentOptionList";
import { normalizePaymentMethods } from "../../utils/paymentMethods";
import { isClosedNow } from "../../utils/availability";
import ClosedNotice from "../../new-components/closed-badge/ClosedNotice";

function HouseKeeping() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const [service, setService] = useState([]);
  const [showError, setShowError] = useState(false);
  const [loading, setLaoding] = useState(false);
  const [title, setTitle] = useState();
  const [hcServices, setHcServices] = useState();
  const [h_images, seth_images] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [housekeepingClosed, setHousekeepingClosed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const params = useParams();
  const { housekeepingId } = useParams();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [selectedOnlinePaymentMethod, setSelectedOnlinePaymentMethod] =
    useState("credit card");

  const { t, i18n } = useTranslation();
  const [showLocationModal, setShowLocationModal] = useState(false);
  // const theme = rawPath.includes("hotel-services");
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  // console.log("theme", theme);

  // console.log("hotel-services", service);

  const toggleService = (input, name, working_times) => {
    console.log("working_times", working_times);
    if (service.includes(input)) {
      ReactGA.event({
        category: "Add HouseKeeping",
        action: "Click",
        value: `HouseKeeping: ${name}`,
      });
      setService((prev) => {
        return prev.filter((x) => x !== input);
      });
    } else {
      setService((prev) => [...prev, input]);
    }
    console.log(service);
  };
  const lang = sessionStorage.getItem("lang");
  const currency = localStorage.getItem("currency");
  const color = localStorage.getItem("color");
  const submitHousekeepingOrder = () => {
    setIsDisabled(true);
    axios
      .post(
        `/${room_uuid}/housekeeping/${housekeepingId}/order`,
        {
          services: service.map((id) => ({
            service_id: id,
          })),
          is_express: 0,
          payment_method: selectedPaymentMethod,
        },
        {
          headers: {
            lang,
          },
        }
      )
      .then((res) => {
        setIsDisabled(false);

        if (res.data.status || res.data.success) {
          navigate(`/${room_uuid}/HKOrderPlaced`);
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
      });
  };
  const handleBook = () => {
    if (service.length <= 0) {
      setShowError(true);
      return;
    }

    setShowError(false);
    setShowLocationModal(true);
  };
  const handleLocationVerified = () => {
    setShowLocationModal(false);
    submitHousekeepingOrder();
  };
  useEffect(() => {
    const getData = async () => {
      setLaoding(true);
      axios
        .get(`/${room_uuid}/housekeeping/${housekeepingId}`, {
          headers: {
            lang: lang,
          },
        })
        .then((res) => {
          if (res.data.status === false) {
            navigate(`/${room_uuid}/qr-scan`);
          } else {
            const data = res.data.data;

            setHcServices(data.housekeeping?.services);
            setHousekeepingClosed(
              isClosedNow(data.housekeeping) || isClosedNow(data)
            );
            const methods = normalizePaymentMethods(
              data.housekeeping?.payment_methods
            );
            setPaymentMethods(methods);
            setSelectedPaymentMethod(methods[0]?.payment_method || "");

            setTitle(data.title);
            seth_images(
              data.housekeeping?.banners?.map((banner) => banner.image) || []
            );
            console.log(data);
            setLaoding(false);
          }
        })
        .catch((err) => {
          if (err?.response.status == 404) {
            // navigate(`/not-found`);
          }
        });
    };
    getData();
  }, []);
  // const price = 100;
  return (
    <div className={theme ? "food pb-0" : ""}>
      {theme ? <Title title={title} /> : <HeaderInner headerName={title} />}
      <main className="home-main bg-white back-white pad-top-0 house">
        {loading ? (
          <SpaLoader />
        ) : (
          <>
            {theme ? (
              <BannerServices headerImages={h_images} />
            ) : (
              <SpaCarosle
                noDots={true}
                autoPlay={true}
                isSalon={true}
                salonImg={h_images}
              />
            )}
            {housekeepingClosed && <ClosedNotice />}
            <div className="housekeeping-container">
              <p className="service">{t("Choose a Service")}</p>
              <div className="service-container">
                {hcServices &&
                  hcServices.map((prop) => {
                    const {
                      service_id,
                      service_name,
                      is_green,
                      activeSubCategories,
                      price,
                      description,
                      working_times,
                    } = prop;

                    return (
                      <>
                        {activeSubCategories?.length > 0 ? (
                          <>
                            <Accordion
                              multiple
                              expandIcon="fa fa-plus"
                              collapseIcon="fa fa-minus"
                              className="mb-3 acor_house"
                            >
                              <AccordionTab
                                key={"Disclaimer"}
                                header={
                                  <>
                                    <span>{service_name}</span>
                                    {price != 0 && (
                                      <span className="house_price">
                                        {price}{" "}
                                        {currency === "SAR" ? (
                                          <Sar color="currentcolor" />
                                        ) : (
                                          `${currency} `
                                        )}
                                      </span>
                                    )}
                                  </>
                                }
                                disabled={false}
                              >
                                {activeSubCategories?.map((item) => {
                                  return (
                                    <Button
                                      className={
                                        service.includes(item.id)
                                          ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                              item.is_green == 1
                                                ? "is_green"
                                                : ""
                                            }`
                                          : "reg-btn outline-btn d-flex justify-content-center "
                                      }
                                      style={
                                        service.includes(item.id)
                                          ? {
                                              backgroundClor: "#006390",
                                            }
                                          : {}
                                      }
                                      onClick={() =>
                                        toggleService(
                                          item.id,
                                          item.name,
                                          working_times
                                        )
                                      }
                                    >
                                      <span>{item.name}</span>
                                      {item?.price != 0 && (
                                        <span className="house_price">
                                          {item?.price}{" "}
                                          {currency === "SAR" ? (
                                            <Sar color="currentcolor" />
                                          ) : (
                                            `${currency} `
                                          )}
                                        </span>
                                      )}
                                      {item.is_green == 1 && (
                                        <img
                                          className="green_img"
                                          src={Green}
                                          alt=""
                                          width={25}
                                          height={25}
                                        />
                                      )}
                                    </Button>
                                  );
                                })}
                              </AccordionTab>
                            </Accordion>
                            {description && (
                              <>
                                <p className="desc">{description}</p>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <Button
                              className={
                                service.includes(service_id)
                                  ? `reg-btn outline-btn dark d-flex justify-content-center  ${
                                      is_green == 1 ? "is_green" : ""
                                    }`
                                  : "reg-btn outline-btn d-flex justify-content-center "
                              }
                              style={
                                service.includes(service_id)
                                  ? {
                                      backgroundClor: "#006390",
                                    }
                                  : {}
                              }
                              onClick={() =>
                                toggleService(
                                  service_id,
                                  service_name,
                                  working_times
                                )
                              }
                            >
                              <span>{service_name}</span>
                              {price != 0 && (
                                <span className="house_price">
                                  {price}{" "}
                                  {currency === "SAR" ? (
                                    <Sar color="currentcolor" />
                                  ) : (
                                    `${currency} `
                                  )}
                                </span>
                              )}
                              {is_green == 1 && (
                                <img
                                  className="green_img"
                                  src={Green}
                                  alt=""
                                  width={25}
                                  height={25}
                                />
                              )}
                            </Button>
                            {description && (
                              <>
                                <p className="desc">{description}</p>
                              </>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
              </div>
              {showError ? (
                <p className="no-service">{t("Choose a service")} </p>
              ) : null}
              {paymentMethods.length > 0 && (
                <div className="mb-4">
                  <div className="full-heading payment flex">
                    <h2>{t("Payment Options")}</h2>
                  </div>
                  <PaymentOptionList
                    selected={selectedPaymentMethod}
                    setSelected={setSelectedPaymentMethod}
                    methods={paymentMethods}
                    setSelectedOnlinePaymentMethod={
                      setSelectedOnlinePaymentMethod
                    }
                  />
                </div>
              )}
              <div className="book">
                <Button
                  onClick={handleBook}
                  disabled={isDisabled || housekeepingClosed}
                  className="reg-btn"
                >
                  {t("request")}
                </Button>
                {/* <h3 className="text-center">
                  <TaxInclusive />
                </h3> */}
              </div>
            </div>
          </>
        )}
      </main>
      {theme && <NewFooter />}
      <LocationVerificationModal
        show={showLocationModal}
        room_uuid={room_uuid}
        theme={theme}
        onVerified={handleLocationVerified}
      />
    </div>
  );
}
export default HouseKeeping;
